import FetchError from './errors'
import { customFetchWithRetry } from './shared'
import { ISubscriptionPlan, ISubscriptionPlansResponse, IUserSubscription } from 'src/models/Subscription'

const baseUserPath = (u: string) => `/user/${u}/subscription`

export const getAllSubscriptionPlans = async (username: string): Promise<ISubscriptionPlansResponse | null> => {
  try {
    if (!username || username.trim() === '') {
      throw new Error('Username is required and cannot be empty');
    }
    const requestUrl = `/user/${username}/subscription/plans`;
    console.log(`Request URL (no encoding): ${requestUrl}`);

    const response = await customFetchWithRetry(requestUrl, {
      method: "GET",
    });

    if (response.ok) {
      const data = await response.json();
      // API returns { monthly: [...], annual: [...] }
      return data as ISubscriptionPlansResponse;
    }

    throw new FetchError(`Error fetching subscription plans. ${await response.text()}`, response.status);

  } catch (e) {
    if (e instanceof FetchError) {
      throw e;
    }
    if (e instanceof Error) {
      throw new FetchError(e.message, 500);
    }
    throw new FetchError('Unknown error occurred', 500);
  }
};

export const getUserSubscriptions = async (u: string): Promise<IUserSubscription[]> => {
  const resp = await customFetchWithRetry(baseUserPath(u), { method: 'GET' })
  if (!resp.ok) throw new FetchError(`Fetching user subscriptions failed. ${await resp.text()}`, resp.status)
  const data = await resp.json()
  // Backend now returns subscriptions with usage info in correct format
  return data as IUserSubscription[]
}

export const createUserSubscription = async (
  u: string,
  payload: Omit<IUserSubscription, 'subscriptionId'>
): Promise<{ subscriptionId: string }> => {
  const resp = await customFetchWithRetry(baseUserPath(u), {
    method: 'POST',
    body: JSON.stringify(payload)
  })
  if (!resp.ok) throw new FetchError(`Creating subscription failed. ${await resp.text()}`, resp.status)
  return resp.json()
}

export const deleteUserSubscription = async (u: string, id: string): Promise<void> => {
  const resp = await customFetchWithRetry(`${baseUserPath(u)}/${id}`, { method: 'DELETE' })
  if (!resp.ok) throw new FetchError(`Deleting subscription failed. ${await resp.text()}`, resp.status)
}